/**
 * Bounded browser identity diagnostics for Cognitory landing sign-in.
 *
 * Mirrors the PR #1853 approval constants and hash-only audit fields without
 * importing backend modules. Raw UID is never returned by the public helpers.
 */

export const APPROVED_PRODUCTION_OWNER_LOGIN_EMAIL =
  "psimonson@southalabama.edu" as const;

export const APPROVED_FIREBASE_PROJECT_ID = "smallgistics-cd63d" as const;

export type BoundedIdentityDiagnostics = {
  email: string;
  uidLength: number;
  uidSha256: string;
  projectId: typeof APPROVED_FIREBASE_PROJECT_ID;
  accessSetupStatus: "access_setup_in_progress";
  cognitoryAccessActive: false;
  answerRouteMounted: false;
};

export async function sha256Hex(value: string): Promise<string> {
  const data = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(digest))
    .map(byte => byte.toString(16).padStart(2, "0"))
    .join("");
}

export async function buildBoundedIdentityDiagnostics(input: {
  email: string | null | undefined;
  uid: string;
}): Promise<BoundedIdentityDiagnostics> {
  const uid = String(input.uid ?? "");
  return {
    email: String(input.email ?? "").trim(),
    uidLength: uid.length,
    uidSha256: await sha256Hex(uid),
    projectId: APPROVED_FIREBASE_PROJECT_ID,
    accessSetupStatus: "access_setup_in_progress",
    cognitoryAccessActive: false,
    answerRouteMounted: false,
  };
}
